// extracted by extract-css-chunks-webpack-plugin
module.exports = {"table":"table___Xkvao","icon":"icon___12UKF"};